import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../login/AuthProvider";
import { teacher } from '../../components/apipath';
import SwitchBox from "../../components/switchBox";
import {switchHelper} from "../../modules/helpers";
import { file_upload } from '../../components/apipath';
import { subjectDict, xtypeDict, subject2Dict, xtype2Dict } from "../../modules/datalist";

function AdmTeacher() {
    const [teacherlist, setTeacherlist] = useState([]);
    const [editingTeacher, setEditingTeacher] = useState(null);
    const [updatedData, setUpdatedData] = useState({});
    const [newTeacher, setNewTeacher] = useState(null); // 用於保存新行的數據
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const { token } = useAuth();
    

    //Read 將後端 Teacher 所有員工資訊導入
    const fetchData = async () => {
        try {
            setLoading(true); // 開始加載
            const response = await axios.get(`${teacher}`, {headers:{token: token}});
            setTeacherlist(response.data);
            setLoading(false); // 完成加載
        } catch (error) {
            console.error('Error:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    //Update 設定編輯狀態
    const startEditing = (teacher) => {
        setEditingTeacher(teacher);
        setUpdatedData(teacher);
    };
    const handleInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (/^((subject)|(xtype))[2]?_[0-9]+$/.test(name)){
            let tmpValue = [];
            document.getElementsByName(name).forEach((item)=>{
                if (item.checked) tmpValue.push(item.value);
            })
            setUpdatedData({
                ...updatedData,
                [name.split('_')[0]]: tmpValue.join(','),
            });
        } else if (['checkbox'].includes(type)){
            setUpdatedData({
                teacher_id: editingTeacher.teacher_id,
                ...updatedData,
                [name]: switchHelper(checked),
            });
        } else {
            setUpdatedData({
                teacher_id: editingTeacher.teacher_id,
                ...updatedData,
                [name]: value,
            });
        }
    };
    //Update 將資訊依照teacher_id回傳給後端
    const saveChanges = async () => {
        try {
            await axios.put(`${teacher}`, updatedData, {
                headers: {
                    token: token,
                    Authorization: `Bearer ${token}`
                }
            });
    
            const updatedTeacherList = teacherlist.map(teacher => {
                if (teacher.teacher_id === editingTeacher.teacher_id) {
                    return updatedData;
                }
                return teacher;
            });
            setTeacherlist(updatedTeacherList);
            setEditingTeacher(null);
        } catch (error) {
            console.error('Error updating teacher:', error);
        }
    };

    // Create 點擊新增按鈕時的處理函數
    const handleAddNew = () => {
        setNewTeacher({
            name: '',
            email: '',
            password: '',
            subject: '',
            xtype: '',
            subject2: '',
            xtype2: '',
            status: 1,
        });
    };


    // Create 處理新行輸入的變化
    const handleNewInputChange = (e) => {
        const { name, value, checked, type } = e.target;
        if (['subject', 'xtype', 'subject2', 'xtype2'].includes(name)){
            let tmpValue = [];
            document.getElementsByName(name).forEach((item)=>{
                if (item.checked) tmpValue.push(item.value);
            })
            setNewTeacher({
                ...newTeacher,
                [name]: tmpValue.join(','),
            });
        } else if (['checkbox'].includes(type)){
            setNewTeacher({
                ...newTeacher,
                [name]: switchHelper(checked),
            });
        } else {
            setNewTeacher({
                ...newTeacher,
                [name]: value,
            });
        }
    };

    // Create 保存新行
    const handleSaveNew = async () => {
        try {
            // 發送 POST 請求將新員工數據保存到後端
            const response = await axios.post(`${teacher}`, newTeacher, {headers:{token: token}});
            if (response.data.status === 200){
                // 新增成功，顯示成功通知
                alert('新增成功！');
                // 將新的員工數據添加到 teacherlist 狀態中
                let newData = newTeacher;
                newData.teacher_id = response.data.data[0].insertId;
                setTeacherlist([...teacherlist, newData]);
                // 重置 newTeacher 狀態
                setNewTeacher(null);
                // 跳轉到另一個頁面（例如員工列表頁）
                //navigate('/adm/admteacher'); // 請根據您的路由結構指定正確的路徑
            } else {
                console.error('Error saving new teacher:', response.data.msg);
            }
            
        } catch (error) {
            console.error('Error saving new teacher:', error);
        }
    };

    return (
        <>
            <div className="mt100 w-75 mx-auto">
                <div className="text-end mt-2">
                    <button className="btn btn-success me-2" onClick={handleAddNew}>新增</button>
                </div>
                <div className="mt-2 table-responsive">
                    <table className="table table-striped border table-hover">
                        <thead>
                            <tr className="text-center">
                                <th>姓名</th>
                                <th>信箱</th>
                                <th>CPA科目</th>
                                <th>CPA題型</th>
                                <th>CMA科目</th>
                                <th>CMA題型</th>
                                <th>狀態</th>
                                <th>功能</th>
                                <th>修改</th>
                            </tr>    
                        </thead>
                        <tbody>
                            {/* 渲染新行 */}
                            {newTeacher && (
                                <tr>
                                    <td colSpan={8}>
                                        <div className="row g-2">
                                            <div className="col-xl-4 col-md-12 col-12">
                                                <div className="input-group input-group-sm">
                                                    <div className="input-group-text">姓名</div>
                                                    <input
                                                        className="border border-primary form-control form-control-sm"
                                                        type="text"
                                                        name="name"
                                                        value={newTeacher.name}
                                                        onChange={handleNewInputChange}
                                                        required // 必填
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-md-12 col-12">
                                                <div className="input-group input-group-sm">
                                                    <div className="input-group-text">帳號 & 信箱</div>
                                                    <input
                                                        className="border border-primary form-control form-control-sm"
                                                        type="text"
                                                        name="email"
                                                        value={newTeacher.email}
                                                        onChange={handleNewInputChange}
                                                        required // 必填
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-md-12 col-12">
                                                <div className="input-group input-group-sm">
                                                    <div className="input-group-text">密碼</div>
                                                    <input
                                                        className="border border-primary form-control form-control-sm"
                                                        type="password"
                                                        name="password"
                                                        value={newTeacher.password}
                                                        onChange={handleNewInputChange}
                                                        required // 必填
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-md-12 col-12">
                                                <div className="card">
                                                    <div className="card-header text-center text-light bg-success">
                                                        <div className="card-title p-0 m-0">CPA科目</div>
                                                    </div>
                                                    <div className="card-body">
                                                    {
                                                        Object.keys(subjectDict).map((key, index) => ( 
                                                            <div className="form-check mb-2">
                                                                <input
                                                                    id={`subjectN${key}`}
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    name="subject"
                                                                    value={key}
                                                                    onChange={handleNewInputChange}
                                                                />
                                                            <label className="form-check-label" htmlFor={`subjectN${key}`}>{subjectDict[key]}</label>
                                                        </div>
                                                        ))
                                                    }   
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-md-12 col-12">
                                                <div className="card">
                                                    <div className="card-header text-center bg-warning">
                                                        <div className="card-title p-0 m-0">CPA題型</div>
                                                    </div>
                                                    <div className="card-body">
                                                    {
                                                        Object.keys(xtypeDict).map((key, index) => ( 
                                                            <div className="form-check mb-2">
                                                                <input
                                                                    id={`xtypeN${key}`}
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    name="xtype"
                                                                    value={key}
                                                                    onChange={handleNewInputChange}
                                                                />
                                                            <label className="form-check-label" htmlFor={`xtypeN${key}`}>{xtypeDict[key]}</label>
                                                        </div>
                                                        ))
                                                    }   
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-4 col-md-12 col-12">
                                                <div className="card mb-2">
                                                    <div className="card-header text-center bg-danger text-light">
                                                        <div className="card-title p-0 m-0">CMA科目</div>
                                                    </div>
                                                    <div className="card-body">
                                                    {
                                                        Object.keys(subject2Dict).map((key, index) => ( 
                                                            <div className="form-check mb-2">
                                                                <input
                                                                    id={`subject2N${key}`}
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    name="subject2"
                                                                    value={key}
                                                                    onChange={handleNewInputChange}
                                                                />
                                                            <label className="form-check-label" htmlFor={`subject2N${key}`}>{subject2Dict[key]}</label>
                                                        </div>
                                                        ))
                                                    }   
                                                    </div>
                                                </div>
                                                <div className="card">
                                                    <div className="card-header text-center bg-info">
                                                        <div className="card-title p-0 m-0">CMA題型</div>
                                                    </div>
                                                    <div className="card-body">
                                                    {
                                                        Object.keys(xtype2Dict).map((key, index) => ( 
                                                            <div className="form-check mb-2">
                                                                <input
                                                                    id={`xtype2N${key}`}
                                                                    className="form-check-input"
                                                                    type="checkbox"
                                                                    name="xtype2"
                                                                    value={key}
                                                                    onChange={handleNewInputChange}
                                                                />
                                                            <label className="form-check-label" htmlFor={`xtype2N${key}`}>{xtype2Dict[key]}</label>
                                                        </div>
                                                        ))
                                                    }   
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        {/* 保存和取消按鈕 */}
                                        <button
                                            className="btn btn-primary m-1"
                                            onClick={handleSaveNew}
                                        >
                                            保存
                                        </button>
                                        <button
                                            className="btn btn-secondary m-1"
                                            onClick={() => setNewTeacher(null)}
                                        >
                                            取消
                                        </button>
                                    </td>
                                </tr>
                            )}
                            {teacherlist.map((teacher) => (
                                <tr key={teacher.teacher_id}>
                                    {editingTeacher && editingTeacher.teacher_id === teacher.teacher_id ? (
                                        <td colSpan={6}>
                                            <div className="row g-2">
                                                <div className="col-xl-4 col-md-12 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <div className="input-group-text">姓名</div>
                                                        <input
                                                            className="border border-primary form-control form-control-sm"
                                                            type="text"
                                                            name="name"
                                                            value={updatedData.name}
                                                            onChange={handleInputChange}
                                                            required // 必填
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-md-12 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <div className="input-group-text">帳號 & 信箱</div>
                                                        <input
                                                            className="border border-primary form-control form-control-sm"
                                                            type="text"
                                                            name="email"
                                                            value={updatedData.email}
                                                            onChange={handleInputChange}
                                                            required // 必填
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-md-12 col-12">
                                                    <div className="input-group input-group-sm">
                                                        <div className="input-group-text">密碼</div>
                                                        <input
                                                            className="border border-primary form-control form-control-sm"
                                                            type="password"
                                                            name="password"
                                                            value={updatedData.password}
                                                            onChange={handleInputChange}
                                                            required // 必填
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-md-12 col-12">
                                                    <div className="card">
                                                        <div className="card-header text-center text-light bg-success">
                                                            <div className="card-title p-0 m-0">CPA科目</div>
                                                        </div>
                                                        <div className="card-body">
                                                        {
                                                            Object.keys(subjectDict).map((key, index) => ( 
                                                                <div className="form-check mb-2">
                                                                    <input
                                                                        id={`subjectU${key}_${teacher.teacher_id}`}
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        name={`subject_${teacher.teacher_id}`}
                                                                        value={key}
                                                                        checked={(updatedData.subject + "").split(',').includes(key)}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                <label className="form-check-label" htmlFor={`subjectU${key}_${teacher.teacher_id}`}>{subjectDict[key]}</label>
                                                            </div>
                                                            ))
                                                        }   
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-md-12 col-12">
                                                    <div className="card">
                                                        <div className="card-header text-center bg-warning">
                                                            <div className="card-title p-0 m-0">CPA題型</div>
                                                        </div>
                                                        <div className="card-body">
                                                        {
                                                            Object.keys(xtypeDict).map((key, index) => ( 
                                                                <div className="form-check mb-2">
                                                                    <input
                                                                        id={`xtypeU${key}_${teacher.teacher_id}`}
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        name={`xtype_${teacher.teacher_id}`}
                                                                        value={key}
                                                                        checked={(updatedData.xtype + "").split(',').includes(key)}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                <label className="form-check-label" htmlFor={`xtypeU${key}_${teacher.teacher_id}`}>{xtypeDict[key]}</label>
                                                            </div>
                                                            ))
                                                        }   
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-4 col-md-12 col-12">
                                                    <div className="card mb-2">
                                                        <div className="card-header text-center bg-danger text-light">
                                                            <div className="card-title p-0 m-0">CMA科目</div>
                                                        </div>
                                                        <div className="card-body">
                                                        {
                                                            Object.keys(subject2Dict).map((key, index) => ( 
                                                                <div className="form-check mb-2">
                                                                    <input
                                                                        id={`subject2U${key}_${teacher.teacher_id}`}
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        name={`subject2_${teacher.teacher_id}`}
                                                                        value={key}
                                                                        checked={(updatedData.subject2 + "").split(',').includes(key)}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                <label className="form-check-label" htmlFor={`subject2U${key}_${teacher.teacher_id}`}>{subject2Dict[key]}</label>
                                                            </div>
                                                            ))
                                                        }   
                                                        </div>
                                                    </div>
                                                    <div className="card">
                                                        <div className="card-header text-center bg-info">
                                                            <div className="card-title p-0 m-0">CMA題型</div>
                                                        </div>
                                                        <div className="card-body">
                                                        {
                                                            Object.keys(xtype2Dict).map((key, index) => ( 
                                                                <div className="form-check mb-2">
                                                                    <input
                                                                        id={`xtype2U${key}_${teacher.teacher_id}`}
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        name={`xtype2_${teacher.teacher_id}`}
                                                                        value={key}
                                                                        checked={(updatedData.xtype2 + "").split(',').includes(key)}
                                                                        onChange={handleInputChange}
                                                                    />
                                                                <label className="form-check-label" htmlFor={`xtype2U${key}_${teacher.teacher_id}`}>{xtype2Dict[key]}</label>
                                                            </div>
                                                            ))
                                                        }   
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    ) : (
                                        <>
                                            <td>{teacher.name}</td>
                                            <td>{teacher.email}</td>
                                            <td>
                                                {
                                                    (teacher.subject + "").split(',').map((item)=>(
                                                        <div>{item ? <i className="fa-solid fa-check fa-fw text-success me-1"></i> : ''}{subjectDict[item]}</div>
                                                    ))
                                                }   
                                            </td>
                                            <td>
                                                {
                                                    (teacher.xtype + "").split(',').map((item)=>(
                                                        <div>{item ? <i className="fa-solid fa-check-double fa-fw text-warning me-1"></i> : ''}{xtypeDict[item]}</div>
                                                    ))
                                                }   
                                            </td>
                                            <td>
                                                {
                                                    (teacher.subject2 + "").split(',').map((item)=>(
                                                        <div>{item ? <i className="fa-regular fa-square-check fa-fw text-danger me-1"></i> : ''}{subject2Dict[item]}</div>
                                                    ))
                                                }   
                                            </td>
                                            <td>
                                                {
                                                    (teacher.xtype2 + "").split(',').map((item)=>(
                                                        <div>{item ? <i className="fa-regular fa-circle-check fa-fw text-info me-1"></i> : ''}{xtype2Dict[item]}</div>
                                                    ))
                                                }   
                                            </td>
                                        </>
                                    )}
                                    
                                    <td>
                                        {editingTeacher && editingTeacher.teacher_id === teacher.teacher_id ? (
                                            SwitchBox('status', updatedData.status, handleInputChange)
                                        ) : (
                                            teacher.status === 0 ? "停用" : "啟用"
                                        )}
                                    </td>
                                    <td>
                                        <div>
                                            <a href={`${file_upload}teacher/${teacher.teacher_id}/tResume`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">履歷</a>
                                            <a href={`${file_upload}teacher/${teacher.teacher_id}/tVideo`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">試教影片</a>
                                            <a href={`${file_upload}teacher/${teacher.teacher_id}/tContract`} target="_blank" rel="noreferrer" className="btn btn-secondary btn-sm m-1 p-1">合約</a>
                                        </div>
                                    </td>
                                    <td>
                                        {editingTeacher && editingTeacher.teacher_id === teacher.teacher_id ? (
                                            <>
                                                <button
                                                    className="btn btn-primary m-1"
                                                    onClick={saveChanges}
                                                >
                                                    保存
                                                </button>
                                                <button
                                                    className="btn btn-secondary m-1"
                                                    onClick={() => setEditingTeacher(null)}
                                                >
                                                    取消
                                                </button>
                                            </>
                                        ) : (
                                            <button
                                                className="btn btn-primary m-1"
                                                onClick={() => startEditing(teacher)}
                                            >
                                                編輯
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}
export default AdmTeacher;